import React, { createContext, useContext } from 'react';
import type { HeaderProps } from './Header';

export interface LayoutContextValue {
  layoutActive: boolean;
  headerProps: HeaderProps | undefined;
  setHeaderProps: (props: HeaderProps | undefined) => void;
}

const LayoutContext = createContext<LayoutContextValue | undefined>(undefined);

export const useLayoutContext = (): LayoutContextValue | undefined => useContext(LayoutContext);

export const LayoutProvider: React.FC<React.PropsWithChildren<{
  value: LayoutContextValue;
}>> = ({ value, children }) => {
  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
};


